import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useScrollTo } from "@/components/SmoothScroll";

/* Remounts the page wrapper on route change so the new page glides in (CSS keyframe) and the window
   jumps back to the top. The very first page renders instantly — no fade — so the static HTML shell in
   index.html hands over to React without a flicker. */
export const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const scrollTo = useScrollTo();
  const initialPath = useRef(pathname);
  const navigated = useRef(false);
  if (pathname !== initialPath.current) navigated.current = true;

  useLayoutEffect(() => {
    if (pathname === initialPath.current && !navigated.current) return;
    scrollTo(0, { immediate: true });
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      key={pathname}
      data-testid="page-transition"
      className={`min-h-full ${navigated.current ? "page-enter" : ""}`}
    >
      {children}
    </div>
  );
};
